import { useEffect, useState } from "react";
import i1 from "../assets/HeroImage1.png";
import i2 from "../assets/HeroImage2.png";
import i3 from "../assets/HeroImage3.png";
import i4 from "../assets/HeroImage4.png";

const imgs = [i1, i2, i3, i4];

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % imgs.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{ width: "100vw", overflow: "hidden" }}>
      <div
        style={{
          display: "flex",
          width: `${imgs.length * 100}vw`,
          transform: `translateX(-${index * 100}vw)`,
          transition: "transform 0.6s ease-in-out",
        }}
      >
        {imgs.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`hero-${i}`}
            style={{ width: "100vw", display: "block" }}
          />
        ))}
      </div>
    </div>
  );
}
